import src from "IMAGE";
export default { src, width: 403, height: 56, blurWidth: 0, blurHeight: 0};
